import React, { useLayoutEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { SvgIcon } from '@material-ui/core'
import { TreeItem, TreeView } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

function MinusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
        </SvgIcon>
    );
}

function PlusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
        </SvgIcon>
    );
}

function CloseSquare(props) {
    return (
        <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
        </SvgIcon>
    );
}

const useStyles = makeStyles({
    root: {
        height: 264,
        flexGrow: 1,
    },
});

export default function RenderTreeMenu({ object, action }) {
    const [t] = useTranslation()
    const classes = useStyles()
    return (
        <div align='left'>
            <div align='center' style={{ backgroundColor: '#01579b', color: '#ffffff', position: 'sticky', top: 0, zIndex: 1 }}>{t('Danh mục')}</div>
            {
                object &&
                <TreeView
                    className={classes.root}
                    defaultExpanded={['1']}
                    defaultCollapseIcon={<MinusSquare />}
                    defaultExpandIcon={<PlusSquare />}
                    defaultEndIcon={<CloseSquare />}
                >
                    {
                        Object.keys(object).filter(key => key !== '').map((key, index) =>
                            <RecursiveTree data={object[key]} index={index} label={key} key={`${key}${index}`} handleClick={data => action(data)} />
                        )
                    }
                </TreeView>
            }
        </div>
    )
}
function RecursiveTree({ data, label, index, handleClick }) {
    if (!data) return ''
    if (label) return (
        <TreeItem label={<div style={{ display: 'flex' }}>{label}</div>} nodeId={label + index} onLabelClick={(e) => { e.preventDefault(); handleClick(data) }}>
            {
                typeof (data) === "object" && data !== null && !Array.isArray(data) && Object.keys(data).map((key, indexx) =>
                    <RecursiveTree index={`${key}${index}${indexx}`} data={data[key]} label={key} key={`${key}${indexx}`} handleClick={(data) => handleClick(data)} />
                )
            }
        </TreeItem>
    )
    else return (
        <>
            {
                Object.keys(data).map((key, indexx) =>
                    <RecursiveTree data={data[key]} index={`${key}${index}${indexx}`} label={key} key={`${key}${index}`} handleClick={handleClick} />
                )
            }
        </>
    )
}

export const TreeMenu = ({ data, onClick, isExpand, onExpand }) => {
    const [t] = useTranslation()
    const classes = useStyles()
    const collapseStyle = { transform: !isExpand && `rotate(90deg) translateY(-20px)`, transformOrigin: 'top left', width: !isExpand && 350 }
    const [expanded, setExpanded] = useState([])
    useLayoutEffect(() => {
        setExpanded([])
    }, [isExpand])
    if (data) return (
        <div align='left' style={{ width: isExpand ? 350 : 20, transition: '0.5s ease all', minHeight: '60vh' }}>
            <div style={{ position: 'sticky', top: 50, maxHeight: '70vh', minHeight: '40vh', height: '100%', overflow: 'hidden auto', bottom: 50, width: '100%', transition: '0.5s ease all' }}>
                <div align='center' style={{ backgroundColor: '#01579b', color: '#ffffff', cursor: 'pointer', position: 'sticky', zIndex: 1, top: 0, transition: '0.5s ease all', ...collapseStyle }} onClick={onExpand}>{t('Danh mục')}</div>
                <TreeView selected={null}
                    style={{ width: 350 }}
                    hidden={!isExpand}
                    expanded={expanded}
                    className={classes.root}
                    defaultCollapseIcon={<MinusSquare />}
                    defaultExpandIcon={<PlusSquare />}
                    defaultEndIcon={<CloseSquare />}
                >
                    {data.map((item, index) =>
                        <TreeSubMenu key={index} subData={item} onClick={onClick} nodeId={index.toString()} currentQuery={item.query} onExpandClick={nodeId => setExpanded(prev => expanded.includes(nodeId) ? expanded.filter(i => i !== nodeId) : [...prev, nodeId])} />
                    )}
                </TreeView>

            </div>
        </div >
    )
    return ''
}
const TreeSubMenu = ({ subData, onClick, currentQuery, nodeId, onExpandClick = () => true }) => {
    if (subData.label) return (
        <TreeItem label={subData.label} onLabelClick={(e) => { e.stopPropagation(); onClick(currentQuery) }} nodeId={nodeId} onClick={() => onExpandClick(nodeId)}>
            {
                subData.subMenu?.map((item, index) => {
                    const newQuery = { ...currentQuery, ...item.query }
                    return <TreeSubMenu subData={item} key={index} label={item.label} onClick={onClick} nodeId={`${nodeId}${index}`} currentQuery={newQuery} onExpandClick={onExpandClick} />
                })
            }
        </TreeItem>
    )
    return (
        <>
            {
                subData.subMenu?.map((item, index) => {
                    const newQuery = { ...currentQuery, ...item.query }
                    return <TreeSubMenu subData={item} key={index} label={item.label} onClick={onClick} nodeId={`${nodeId}${index}`} currentQuery={newQuery} onExpandClick={onExpandClick} />
                })
            }
        </>
    )
}